import { Route } from '@angular/router';
import { DashboardIndexComponent } from '@features/dashboard/dashboard-index/dashboard-index.component';

export const dashboard_routes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardIndexComponent,
    title: 'Dashboard'
  }
];
